/**
 * "HH:MM" (ou horas em número) em minutos
 */
export function toMinutes(value) {
	if( value == null ) return 0;
	if( typeof value === "number" ) return Number.isFinite(value) ? Math.round(value * 60) : 0;

	const negative = String(value).trim().startsWith("-");
	const [hours, minutes] = String(value).replace("-", "").split(":");
	const total    = ((Number(hours) || 0) * 60) + (Number(minutes) || 0);

	return negative ? -total : total;
}

/**
 * Minutos em "HH:MM"
 */
export function fromMinutes(minutes) {
	const abs = Math.abs(Math.round(minutes));

	return `${minutes < 0 ? "-" : ""}${String(Math.floor(abs / 60)).padStart(2, "0")}:${String(abs % 60).padStart(2, "0")}`;
}

/**
 * Minutos em "254h 32m"
 */
export function formatHours(minutes) {
	const abs = Math.abs(minutes);

	return `${minutes < 0 ? "-" : ""}${Math.floor(abs / 60)}h ${String(abs % 60).padStart(2, "0")}m`;
}
